import type { BubbleConfig } from "../../data/decor/bubbles";
import { bubbleInlineStyle } from "../../data/decor/bubbles";
import { useReducedMotion } from "../../hooks/useReducedMotion";

type BubbleFieldProps = {
  bubbles: readonly BubbleConfig[];
  className?: string;
  isStatic?: boolean;
};

export function BubbleField({ bubbles, className = "", isStatic = false }: BubbleFieldProps) {
  const reduced = useReducedMotion();

  return (
    <div
      className={["pointer-events-none overflow-hidden", className]
        .filter(Boolean)
        .join(" ")}
      aria-hidden="true"
    >
      {bubbles.map((bubble, index) => (
        <div
          key={`${bubble.color}-${bubble.top}-${index}`}
          className="bubble"
          style={bubbleInlineStyle(bubble, reduced, isStatic)}
        />
      ))}
    </div>
  );
}
